import { useEffect, useState } from "react";
import { ID } from "src/libs/interfaces/layouts";
import { useDataStore } from "src/modules/pe-basic-module/data/store";
import { actions } from "../data/actions";
import { GET_TEST_ACTION } from "../data/actionTypes";
import { IPETest } from "../data/interfaces";

export default function useTest(test_id:ID) {
    const [test, setTest] = useState<IPETest>({} as IPETest)
    const tests : IPETest[] = useDataStore((state:any) => state.PETest || [] )
    useEffect(() => {
        if(!!tests.length) {
            const test = tests.find( t => t.id === test_id)
            if( !!test) {
                setTest(test)
                return
            }
        }
        if( !!test_id ) {
            actions(GET_TEST_ACTION, { id: test_id })
                .then((res: IPETest) => {
                    setTest(res)
                })
        }
    }, [])
    // console.log( test )
    return test
}